import { initProjectsFilteredSearchAndSort } from '~/projects/filtered_search_and_sort';

initProjectsFilteredSearchAndSort({
  sortEventName: 'use_sort_projects_explore',
  filterEventName: 'use_filter_bar_projects_explore',
});
